export type Rol = 'SOLICITANTE' | 'ADMINISTRACION' | 'AUTORIZADOR' | 'RECEPCION' | 'ADMIN';

export type MeResponse = {
  id: string;
  email: string;
  nombre: string;
  roles: Rol[];
  referenteArea: boolean;
  codigoUsuarioFlexxus: string | null;
  notificacionesNoLeidas: number;
  /** Partes de la app que se prenden por configuración (`.env`). */
  funciones?: { pagoEnFlexxus: boolean; facturaEnFlexxus?: boolean };
};

export type UsuarioMockDto = {
  id: string;
  nombre: string;
  email: string;
  descripcion: string;
  roles: Rol[];
};

export type AuthConfigResponse = {
  mode: 'msal' | 'mock';
  usuariosMock?: UsuarioMockDto[];
  /**
   * `false` cuando el registro de aplicaciones todavía no está habilitado para
   * loguear (falta el consentimiento del admin del tenant). El login se dibuja
   * igual, con el botón deshabilitado y el motivo a la vista.
   */
  microsoftHabilitado?: boolean;
  motivoMicrosoftDeshabilitado?: string;
  /**
   * Modo mock: con quién entra el botón principal, para que el login se vea igual
   * que en producción en lugar de arrancar con la lista de usuarios de prueba.
   */
  mockUsuarioDefault?: string;
};

/**
 * Quién da de alta proveedores: solo los contadores (decisión del usuario,
 * 2026-09-25), más ADMIN, que es el rol técnico. Lo usan el menú, la ruta
 * `/proveedores/nuevo` y el botón del buscador de proveedores; el backend exige
 * lo mismo en `POST /api/config/proveedores`.
 */
export const ROLES_ALTA_PROVEEDOR: Rol[] = ['ADMINISTRACION', 'ADMIN'];

export function puedeDarAltaProveedor(roles: Rol[]): boolean {
  return roles.some((r) => ROLES_ALTA_PROVEEDOR.includes(r));
}

export const HOME_POR_ROL: Record<Rol, string> = {
  SOLICITANTE: '/compras',
  ADMINISTRACION: '/administracion',
  AUTORIZADOR: '/aprobaciones',
  RECEPCION: '/recepcion',
  // El Panel se eliminó: su tabla repetía el listado de compras.
  ADMIN: '/compras',
};

export function homeParaRoles(roles: Rol[]): string {
  // Orden de preferencia: ADMIN > AUTORIZADOR > ADMINISTRACION > RECEPCION > SOLICITANTE
  const orden: Rol[] = ['ADMIN', 'AUTORIZADOR', 'ADMINISTRACION', 'RECEPCION', 'SOLICITANTE'];
  for (const r of orden) if (roles.includes(r)) return HOME_POR_ROL[r];
  return '/sin-acceso';
}
